import { render, staticRenderFns } from "./TemporaryAccess.vue?vue&type=template&id=ae173bfa&scoped=true&"
import script from "./TemporaryAccess.vue?vue&type=script&lang=js&"
export * from "./TemporaryAccess.vue?vue&type=script&lang=js&"
import style0 from "./TemporaryAccess.vue?vue&type=style&index=0&id=ae173bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae173bfa",
  null
  
)

export default component.exports